import styled from 'styled-components';

export const SocialItem = styled.a`
  width: 100%;
  padding-top: 100%;
  border: 1px solid white;
  position: relative;
`;

export const SocialItemOverlay = styled.div`
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  top: 0;
  display: flex;
  justify-content: center;
  align-items: center;
`;
